export const queryKeys = {
    GOOGLE_AUTH_LOGOUT: 'GOOGLE_AUTH_LOGOUT',
    POST_TELEGRAM_ADD: 'POST_TELEGRAM_ADD',
    DELETE_TELEGRAM_REMOVE: 'DELETE_TELEGRAM_REMOVE',
    ISHAVE_TELEGRAM: 'ISHAVE_TELEGRAM'
}